import { ShipmentStatus } from '../shipment/ShipmentStatus';
import { TenderRequest } from '../tender/TenderRequest';

export class BulkTenderResult {
  shipmentId?: number;
  status?: ShipmentStatus;
  originName?: string;
  destinationName?: string;
  request?: TenderRequest;
  errors?: string;

  constructor(opts?: Partial<BulkTenderResult>) {
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.status != null) {
      this.status = opts.status;
    }
    if (opts?.originName != null) {
      this.originName = opts.originName;
    }
    if (opts?.destinationName != null) {
      this.destinationName = opts.destinationName;
    }
    if (opts?.request != null) {
      this.request = new TenderRequest(opts.request);
    }
    if (opts?.errors != null) {
      this.errors = opts.errors;
    }
  }
}
